import { useEffect, useState } from 'react';
import { useVerifySmartLinkSlugMutation } from '../../../../redux/api/fymAPI';
import { AddressState } from '../../profile/useAccountSlugCheck';

const CHECK_DELAY_MS = 450;

/**
 * The end of a page address, checked while it is typed (design a6), as the account address check
 * (`useAccountSlugCheck`) but with the page call. The page's own id goes with the request, so its
 * saved address never comes back as taken.
 */
export function useSmartLinkSlugCheck(slug: string, accountId: number, smartLinkId: number, savedSlug: string) {
  const [verifySlug] = useVerifySmartLinkSlugMutation();
  const [state, setState] = useState(AddressState.idle);
  const [suggestion, setSuggestion] = useState<string>();

  useEffect(() => {
    if (slug === '' || slug === savedSlug) {
      setState(AddressState.idle);
      setSuggestion(undefined);
      return undefined;
    }
    setState(AddressState.checking);
    const timer = setTimeout(() => {
      verifySlug({ slug, accountId, smartLinkId })
        .unwrap()
        .then((result) => {
          setSuggestion(result.availableSlug);
          if (!result.isValid) {
            setState(AddressState.illegal);
            return;
          }
          setState(result.isAvailable ? AddressState.free : AddressState.taken);
        })
        // A check we could not make is not a verdict: the save call checks again.
        .catch(() => setState(AddressState.idle));
    }, CHECK_DELAY_MS);
    return () => clearTimeout(timer);
  }, [accountId, savedSlug, slug, smartLinkId, verifySlug]);

  return { state, suggestion };
}
